/**
 * True when the editor HTML shows no text at all, e.g. the `<p></p><ul><li></li></ul>` skeleton that
 * browser page translation leaves behind in the Quill editor (the 2026-10-03 incident).
 */
export function hasNoVisibleText(html: string | null | undefined): boolean {
  if (typeof html !== 'string') return true;

  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim() === ''
  );
}

export type AdTextField = 'job_description' | 'job_contract_description';

/** The ad text fields edited in a Quill editor that have no visible text, in display order. */
export function findEmptyAdTextFields(values: Partial<Record<AdTextField, string | null>>): AdTextField[] {
  return (['job_description', 'job_contract_description'] as const).filter((field) => hasNoVisibleText(values[field]));
}
